import React from 'react';
export default function IsVisible({ permission, children }) {
  return permission ? children : null;
}
